import _cloneDeep from 'lodash/cloneDeep';
import _has from 'lodash/has';
import _get from 'lodash/get';
import _set from 'lodash/set';
import {evaluate, isDisabled, isRequired} from './index';

const isStaticSingleSelect = field => field?.type === 'select' && !field.multiple && !field.href && Array.isArray(field.options);

export function getSelectDefaultOptions(field) {
    if (!isStaticSingleSelect(field)) return [];
    return field.options
        .filter(option => option && !option.disabled)
        .map(option => ({...option, value: option.value ?? option.label}))
        .filter(option => typeof option.value === 'string' && option.value !== '');
}

export function getSelectDefaultOption(field) {
    return getSelectDefaultOptions(field).find(option => option.value === field.defaultValue);
}

export function preserveSelectClears(fieldsets, values) {
    const result = _cloneDeep(values || {});
    const visit = sections => {
        for (const section of sections || []) {
            for (const field of section.fields || []) {
                if (field.type === 'form-layout') visit(field.fieldsets);
                else if (field.type === 'control-group') visit([field]);
                else if (isStaticSingleSelect(field) && !isRequired(field, result) && _has(result, field.name)
                    && _get(result, field.name) === undefined) _set(result, field.name, null);
            }
        }
    };
    visit(fieldsets);
    return result;
}

// Keep the same set for the draft's lifetime,
// including template changes, so returning to a field never fills it again.
export function initializeRecordValues(fieldsets, values, initializedFieldNames = new Set(), excludedFieldNames = new Set()) {
    const result = _cloneDeep(values || {});
    const visit = (sections, parentVisible = true) => {
        for (const section of sections || []) {
            const sectionVisible = parentVisible && evaluate(null, section.showsWhen, result) !== false
                && !isDisabled(section, result);
            for (const field of section.fields || []) {
                const visible = sectionVisible && evaluate(null, field.showsWhen, result, field) !== false;
                if (field.type === 'form-layout') {
                    visit(field.fieldsets, visible && !isDisabled(field, result));
                } else if (field.type === 'control-group') {
                    visit([field], visible);
                } else if (field.name && !initializedFieldNames.has(field.name)) {
                    initializedFieldNames.add(field.name);
                    if (_has(result, field.name) || excludedFieldNames.has(field.name) || !visible || isDisabled(field, result)) continue;
                    const option = getSelectDefaultOption(field);
                    if (option && evaluate(null, option.showsWhen, result, option) !== false) {
                        _set(result, field.name, option.value);
                    }
                }
            }
        }
    };
    visit(fieldsets);
    return result;
}
